import { SvgIcon, SvgIconProps } from '../SvgIcon';
import { getColor } from '../utils';

export const Unchecked = ({
  height = 24,
  width = 24,
  color = '#B8B1B4',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 24 24" {...props}>
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="1" y="1" width="18" height="18" rx="9" stroke="#B8B1B4" strokeWidth="2" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.4728 6.27348C14.2671 6.05695 13.9336 6.05695 13.7279 6.27348L8.50484 11.7715L6.27213 9.42126C6.06644 9.20476 5.73295 9.20476 5.52726 9.42126L5.15427 9.81392C4.94858 10.0304 4.94858 10.3815 5.15427 10.598L7.76318 13.3443C7.79577 13.3786 7.82998 13.4102 7.86554 13.4391L8.13856 13.7265C8.34425 13.943 8.67774 13.943 8.88345 13.7265L9.18015 13.4142C9.20516 13.3923 9.22945 13.369 9.25294 13.3443L9.6259 12.9517L9.62268 12.9483L14.8457 7.4502C15.0514 7.23368 15.0514 6.88263 14.8457 6.66611L14.4728 6.27348Z"
        fill={getColor(color, isColorInherited)}
      />
    </svg>
  </SvgIcon>
);
